import { render } from "./Panel.vue?vue&type=template&id=a8aaffaa&scoped=true"
const script = {}

import "./Panel.vue?vue&type=style&index=0&id=a8aaffaa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a8aaffaa"

export default script